import { render, staticRenderFns } from "./ScInfoView.vue?vue&type=template&id=6c9b8fc8&"
import script from "./ScInfoView.vue?vue&type=script&lang=js&"
export * from "./ScInfoView.vue?vue&type=script&lang=js&"
import style0 from "./ScInfoView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports